"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRemoteClusterPatch = isRemoteClusterPatch;
function isRemoteClusterPatch(x) {
    return ((x.display_name !== undefined && x.display_name !== '') ||
        x.default_team_id !== undefined);
}
